<template>
  <div class="login-page">
    <div class="login-container">
      <!-- Logo区域 -->
      <div class="logo-section">
        <img src="@/assets/logo (2).png" alt="甜筒星球" class="logo-img" />
        <h1 class="logo-text">甜筒星球</h1>
        <p class="logo-slogan">发现精彩直播，分享美好生活</p>
      </div>

      <!-- 登录/注册表单 -->
      <div class="form-section">
        <!-- 切换标签 -->
        <div class="form-tabs">
          <span 
            :class="['tab-item', { active: activeTab === 'login' }]" 
            @click="activeTab = 'login'"
          >登录</span>
          <span 
            :class="['tab-item', { active: activeTab === 'register' }]" 
            @click="activeTab = 'register'"
          >注册</span>
        </div>

        <!-- 登录表单 -->
        <div v-if="activeTab === 'login'" class="form-content">
          <div class="input-group">
            <input 
              v-model="loginForm.username" 
              type="text" 
              placeholder="请输入用户名/手机号"
              class="form-input"
              @blur="validateLoginUsername"
            />
            <span class="error-msg" v-if="errors.loginUsername">{{ errors.loginUsername }}</span>
          </div>
          <div class="input-group">
            <input 
              v-model="loginForm.password" 
              type="password" 
              placeholder="请输入密码"
              class="form-input"
              @blur="validateLoginPassword"
            />
            <span class="error-msg" v-if="errors.loginPassword">{{ errors.loginPassword }}</span>
          </div>
          <div class="form-options">
            <label class="remember-me">
              <input type="checkbox" v-model="loginForm.remember" />
              <span>记住我</span>
            </label>
            <a href="javascript:void(0)" class="forgot-link" @click="showForgotDialog">忘记密码?</a>
          </div>
          <button class="submit-btn" @click="handleLogin">登录</button>
        </div>

        <!-- 注册表单 -->
        <div v-else class="form-content">
          <div class="input-group">
            <input 
              v-model="registerForm.username" 
              type="text" 
              placeholder="请输入用户名(2-20位字母数字)"
              class="form-input"
              @blur="validateUsername"
            />
            <span class="error-msg" v-if="errors.username">{{ errors.username }}</span>
          </div>
          <div class="input-group">
            <input 
              v-model="registerForm.phone" 
              type="text" 
              placeholder="请输入手机号"
              class="form-input"
              @blur="validatePhone"
            />
            <span class="error-msg" v-if="errors.phone">{{ errors.phone }}</span>
          </div>
          <div class="input-group">
            <input 
              v-model="registerForm.password" 
              type="password" 
              placeholder="请设置密码(6-20位字母数字)"
              class="form-input"
              @blur="validatePassword"
            />
            <span class="error-msg" v-if="errors.password">{{ errors.password }}</span>
          </div>
          <div class="input-group">
            <input 
              v-model="registerForm.confirmPassword" 
              type="password" 
              placeholder="请确认密码"
              class="form-input"
              @blur="validateConfirmPassword"
            />
            <span class="error-msg" v-if="errors.confirmPassword">{{ errors.confirmPassword }}</span>
          </div>
          <div class="input-group verify-group">
            <input 
              v-model="registerForm.verifyCode" 
              type="text" 
              placeholder="请输入验证码(4位数字)"
              class="form-input verify-input"
              @blur="validateVerifyCode"
            />
            <button 
              class="verify-btn" 
              :disabled="countdown > 0"
              @click="sendVerifyCode"
            >
              {{ countdown > 0 ? `${countdown}s后重发` : '获取验证码' }}
            </button>
          </div>
          <span class="error-msg" v-if="errors.verifyCode">{{ errors.verifyCode }}</span>
          <div class="agreement">
            <label>
              <input type="checkbox" v-model="registerForm.agree" />
              <span>我已阅读并同意</span>
            </label>
            <a href="#/xieyi" target="_blank">用户协议</a>
            <span>和</span>
            <a href="#/yinsi" target="_blank">隐私政策</a>
          </div>
          <span class="error-msg" v-if="errors.agree">{{ errors.agree }}</span>
          <button class="submit-btn" @click="handleRegister">注册</button>
        </div>
      </div>

      <!-- 返回首页 -->
      <div class="back-home">
        <router-link to="/">← 返回首页</router-link>
      </div>
    </div>

    <!-- 忘记密码弹窗 -->
    <div v-if="showForgot" class="dialog-overlay" @click.self="showForgot = false">
      <div class="dialog-content">
        <h3>找回密码</h3>
        <p>请联系客服重置密码</p>
        <p>客服电话: 400-123-4567</p>
        <button class="dialog-btn" @click="showForgot = false">知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      activeTab: 'login',
      countdown: 0,
      showForgot: false,
      loginForm: {
        username: '',
        password: '',
        remember: false
      },
      registerForm: {
        username: '',
        phone: '',
        password: '',
        confirmPassword: '',
        verifyCode: '',
        agree: false
      },
      errors: {
        loginUsername: '',
        loginPassword: '',
        username: '',
        phone: '',
        password: '',
        confirmPassword: '',
        verifyCode: '',
        agree: ''
      }
    }
  },
  methods: {
    // 正则验证规则
    validateUsername() {
      const reg = /^[a-zA-Z0-9]{2,20}$/
      if (!this.registerForm.username) {
        this.errors.username = '请输入用户名'
        return false
      } else if (!reg.test(this.registerForm.username)) {
        this.errors.username = '用户名需为2-20位字母或数字'
        return false
      }
      this.errors.username = ''
      return true
    },
    validatePhone() {
      const reg = /^1[3-9]\d{9}$/
      if (!this.registerForm.phone) {
        this.errors.phone = '请输入手机号'
        return false
      } else if (!reg.test(this.registerForm.phone)) {
        this.errors.phone = '请输入正确的11位手机号'
        return false
      }
      this.errors.phone = ''
      return true
    },
    validatePassword() {
      const reg = /^[a-zA-Z0-9]{6,20}$/
      if (!this.registerForm.password) {
        this.errors.password = '请输入密码'
        return false
      } else if (!reg.test(this.registerForm.password)) {
        this.errors.password = '密码需为6-20位字母或数字'
        return false
      }
      this.errors.password = ''
      return true
    },
    validateConfirmPassword() {
      if (!this.registerForm.confirmPassword) {
        this.errors.confirmPassword = '请确认密码'
        return false
      } else if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.errors.confirmPassword = '两次输入的密码不一致'
        return false
      }
      this.errors.confirmPassword = ''
      return true
    },
    validateVerifyCode() {
      const reg = /^\d{4}$/
      if (!this.registerForm.verifyCode) {
        this.errors.verifyCode = '请输入验证码'
        return false
      } else if (!reg.test(this.registerForm.verifyCode)) {
        this.errors.verifyCode = '验证码为4位数字'
        return false
      }
      this.errors.verifyCode = ''
      return true
    },
    validateLoginUsername() {
      if (!this.loginForm.username) {
        this.errors.loginUsername = '请输入用户名或手机号'
        return false
      }
      this.errors.loginUsername = ''
      return true
    },
    validateLoginPassword() {
      if (!this.loginForm.password) {
        this.errors.loginPassword = '请输入密码'
        return false
      } else if (this.loginForm.password.length < 6) {
        this.errors.loginPassword = '密码长度不能少于6位'
        return false
      }
      this.errors.loginPassword = ''
      return true
    },
    showForgotDialog() {
      this.showForgot = true
    },
    handleLogin() {
      const validUsername = this.validateLoginUsername()
      const validPassword = this.validateLoginPassword()
      
      if (!validUsername || !validPassword) {
        return
      }
      
      alert('登录成功！')
      this.$router.push('/')
    },
    handleRegister() {
      const valid = this.validateUsername() && 
                    this.validatePhone() && 
                    this.validatePassword() && 
                    this.validateConfirmPassword() && 
                    this.validateVerifyCode()
      
      if (!valid) {
        return
      }
      
      if (!this.registerForm.agree) {
        this.errors.agree = '请同意用户协议和隐私政策'
        return
      }
      this.errors.agree = ''
      
      alert('注册成功！')
      this.activeTab = 'login'
    },
    sendVerifyCode() {
      if (!this.validatePhone()) {
        return
      }
      
      this.countdown = 60
      const timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(timer)
        }
      }, 1000)
    }
  }
}
</script>

<style scoped lang="scss">
.login-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #FBFAFF 0%, #F3F0FF 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-container {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(138, 63, 252, 0.15);
  padding: 40px;
}

/* Logo区域 */
.logo-section {
  text-align: center;
  margin-bottom: 32px;

  .logo-img {
    width: 80px;
    height: auto;
    object-fit: contain;
    margin-bottom: 16px;
  }

  .logo-text {
    font-size: 24px;
    font-weight: 600;
    color: #8A3FFC;
    margin-bottom: 8px;
  }

  .logo-slogan {
    font-size: 14px;
    color: #9B8DC7;
  }
}

/* 标签切换 */
.form-tabs {
  display: flex;
  margin-bottom: 24px;
  border-bottom: 2px solid #F0F0FF;

  .tab-item {
    flex: 1;
    text-align: center;
    padding: 12px 0;
    font-size: 16px;
    color: #9B8DC7;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;

    &:hover {
      color: #8A3FFC;
    }

    &.active {
      color: #8A3FFC;
      font-weight: 500;

      &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translateX(-50%);
        width: 40px;
        height: 3px;
        background: #8A3FFC;
        border-radius: 2px;
      }
    }
  }
}

/* 表单内容 */
.form-content {
  .input-group {
    margin-bottom: 8px;

    .form-input {
      width: 100%;
      padding: 14px 16px;
      border: 1px solid #E0D5FF;
      border-radius: 12px;
      font-size: 14px;
      color: #4B3B73;
      background: #FAF8FF;
      transition: all 0.3s ease;
      box-sizing: border-box;

      &::placeholder {
        color: #9B8DC7;
      }

      &:focus {
        outline: none;
        border-color: #8A3FFC;
        background: #fff;
      }
    }
  }

  .error-msg {
    display: block;
    font-size: 12px;
    color: #ff4d4f;
    margin-bottom: 8px;
    padding-left: 4px;
  }

  .verify-group {
    display: flex;
    gap: 12px;

    .verify-input {
      flex: 1;
    }

    .verify-btn {
      padding: 0 20px;
      background: #8A3FFC;
      color: #fff;
      border: none;
      border-radius: 12px;
      font-size: 13px;
      cursor: pointer;
      transition: all 0.3s ease;
      white-space: nowrap;

      &:hover:not(:disabled) {
        opacity: 0.9;
      }

      &:disabled {
        background: #C4B5E0;
        cursor: not-allowed;
      }
    }
  }
}

/* 登录选项 */
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  .remember-me {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #666;
    cursor: pointer;

    input {
      width: 16px;
      height: 16px;
      accent-color: #8A3FFC;
    }
  }

  .forgot-link {
    font-size: 13px;
    color: #8A3FFC;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

/* 提交按钮 */
.submit-btn {
  width: 100%;
  padding: 14px 0;
  background: linear-gradient(135deg, #8A3FFC 0%, #A855F7 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }
}

/* 协议 */
.agreement {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  margin: 16px 0;
  font-size: 13px;
  color: #666;

  input {
    width: 16px;
    height: 16px;
    accent-color: #8A3FFC;
  }

  a {
    color: #8A3FFC;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

/* 返回首页 */
.back-home {
  text-align: center;
  margin-top: 24px;

  a {
    font-size: 14px;
    color: #9B8DC7;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #8A3FFC;
    }
  }
}

/* 忘记密码弹窗 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.dialog-content {
  background: #fff;
  padding: 32px;
  border-radius: 16px;
  text-align: center;
  min-width: 280px;

  h3 {
    font-size: 18px;
    color: #333;
    margin-bottom: 16px;
  }

  p {
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
  }

  .dialog-btn {
    margin-top: 20px;
    padding: 10px 32px;
    background: #8A3FFC;
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
  }
}
</style>